import { render, staticRenderFns } from "./BetfairMenu.vue?vue&type=template&id=0acb7fae&"
import script from "./BetfairMenu.vue?vue&type=script&lang=js&"
export * from "./BetfairMenu.vue?vue&type=script&lang=js&"
import style0 from "./BetfairMenu.vue?vue&type=style&index=0&id=0acb7fae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports